import {Injectable, Input} from '@angular/core';
import {ApiService} from '@patientlynk3/services/api/api.service';
import {AuthService} from '@patientlynk3/services/auth/auth.service';
import {ProfileService} from '@patientlynk3/services/profile/profile.service';
import {zip} from 'rxjs';
import {take} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class HraService {
  questions: any;
  responses: any;
  percentage = 0;

  private _questionCount: number;
  private _responseCount: number;
  private _form: any;
  private _formResponseCount: number; // live form response count
  @Input() set responseCount(count: number) {
    this._formResponseCount = count;
    this.percentage = this._calculate(this._questionCount, this._formResponseCount);
  }

  get responseCount() {
    return this._formResponseCount || this._responseCount;
  }

  constructor(private api: ApiService, private auth: AuthService, public profile: ProfileService) { 
    this.auth.isLoggedIn$.subscribe((status) => {
      status ? this.load() : this.clear();
    });
  }

  load() {
    const profile = this.profile.getValue();
    const profileToken = this.auth.getPayload();

    this._getHRAData(profileToken.id).pipe(take(1))
      .subscribe(([questions, responses]: [any, any]) => {
        this.questions = questions;
        this.responses = responses;

        this._questionCount = questions.results[0].sections
          .flatMap(section => section.questions)
          .filter(question => question.order && question.subsection_en)
          .length;
        this._responseCount = responses.results.length ? responses.results[0].hra_response_set.length : 0;
        this.percentage = profileToken.has_completed_hra ? 100 : this._calculate(this._questionCount, this._responseCount);
      });
  }

  refresh() {
    this.load();
  }

  clear() {
    this.questions = this.responses = [];
    this._questionCount = this._responseCount = this._formResponseCount = 0;
  }

  private _getHRAData(profileId: string) {
    return zip(this.api.new_hra_api.surveys(1), this.api.new_hra_api.answers(1, 0)).pipe(take(1));
  }

  private _calculate(questionCount, responseCount) {
    if (!questionCount || !responseCount) { return 0; }
    return Math.min((responseCount / questionCount) * 100, 100);
  }

  async getHRAForm() {
    if (this._form) { return this._form; }
    await this.waitForInit();
    return {questions: this.questions, responses: this.responses};
  }

  // https://stackoverflow.com/questions/45489129/javascript-wait-for-condition-to-be-true-using-promises
  waitForInit() {
    return new Promise<void>(resolve => {
      const start = Date.now();
      const checkFlag = () => {
        if (this.responses || Date.now() > start + 5000) {
          resolve();
        } else {
          window.setTimeout(checkFlag, 50);
        }
      };
      checkFlag();
    });
  }
}
